<template>
    <div class="staff_top">
        <header>
            <a class="header_logo pc_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <a class="header_logo sp_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/sp_logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/NewsList">ニュースリリース</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn btn_color" v-on:click="logout">ログアウト</button>
            </div>
            <div class="burger-btn" @click="naviOpen" :class="{'is-active': active}">
                <span class="bars">
                    <span class="bar bar_top"></span>
                    <span class="bar bar_mid"></span>
                    <span class="bar bar_bottom"></span>
                </span>
            </div>
            <transition name="navi">
                <nav class="navi" v-show="navi">
                    <ul class="navi__wrap">
                        <li><router-link class="header_link header_link2" to="/NewsList">ニュース一覧</router-link></li>
                        <li>{{$store.state.userName}}</li>
                        <li><button class="logout_btn btn_color sp_logout_btn" v-on:click="logout">ログアウト</button></li>
                    </ul>
                </nav>
            </transition>
        </header>
        <h1>ニュースリリース</h1>
        <div class="search_register_btn">
            <div class="search_wrap">
                <p class="interval interval2">配信タイトル</p>
                <input placeholder="検索" class="interval" type="text" v-model="search">
                <!-- <button class="interval">検索</button> -->
            </div>
        </div>
            <div class="number">
                <p class="pagenumber">{{ getMinPage }}〜{{ getMaxPage }}／{{ get_page }}件</p>
            </div>
        <div class="news_list_tables">
            <table class="pc_table">
                <tr class="header_tr">
                    <th class="small_list">配信ID</th>
                    <th>配信日時</th>
                    <th>配信タイトル</th>
                    <th class="small_list">添付</th>
                    <th>最終更新日時</th>
                </tr>
            </table>
            <div class="news_list">
                <div class="sp_table">
                    <p v-if="getLists==''">データがありません</p>
                    <div v-for="e in getLists" :key="e.notice_id">
                        <div class="news_box">
                            <div class="sp_news_header">
                                <div class="td">{{ e.notice_id }}</div>
                                <div class="td" v-bind:class=" e.attached_flg == true ? '' : 'false' ">
                                    <img src="../assets/img/clip.png">
                                </div>
                                <div class="td"><router-link class="sp_a" :to="{name: 'NewsDetail', query: {id: e.notice_id }}" v-html="highLight(e.title)"></router-link></div>
                            </div>
                            <div class="sp_date_wrap">
                                <div class="sp_date_txt">作成日時</div>
                                <div class="sp_date">{{ e.post_date | moment("YYYY/MM/DD HH:mm:ss") }}</div>
                            </div>
                            <div class="sp_date_wrap">
                                <div class="sp_date_txt">最終更新日時</div>
                                <div class="sp_date">{{ e.update_date | moment("YYYY/MM/DD HH:mm:ss") }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <table class="pc_table">
                    <p v-if="getLists==''">データがありません</p>
                    <tr v-for="e in getLists" :key="e.notice_id">
                        <td class="small_list">{{ e.notice_id }}</td>
                        <td>{{ e.post_date | moment("YYYY/MM/DD") }}<br>{{ e.post_date | moment("HH:mm:ss") }}</td>
                        <td>
                            <router-link :to="{name: 'NewsDetail', query: {id: e.notice_id }}" v-html="highLight(e.title)"></router-link>
                        </td>
                        <td class="small_list" v-bind:class=" e.attached_flg == true ? '' : 'false' ">
                            <img src="../assets/img/clip.png">
                        </td>
                        <td>{{ e.update_date | moment("YYYY/MM/DD") }}<br>{{ e.update_date | moment("HH:mm:ss") }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <paginate
            :v-model="currentPage"
            :page-count="getPageCount"
            :click-handler="clickCallback"
            :page-range="3"
            :margin-pages="2"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-link-class="'page-link'"
            :hide-prev-next="true"
            >
        </paginate>
    </div>
</template>

<script>
window.onpageshow = function(event) {
	if (event.persisted) {
		window.location.reload();
	}
};
import axios from 'axios'
export default {
    data () {
        return {
            tweets: [],
            search: '',
            currentPage: 1,
            parPage: 50,
            get_page: 0,
            active: false,
            navi: false,
            url_protcol: 'https://',
            domain: 'staff.ubiquitous-p.com',
            url_path: '/rest/get_notice_staff_list/'
        }
    },
    mounted () {
        this.fetchTweets() // fetchTweetsを呼ぶ
    },
    methods: {
        fetchTweets () {
            axios
            .post(this.url_protcol + this.domain + this.url_path,{},{
                headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
            })
            .then(response => {
            this.tweets = response.data
            this.get_page = response.data.length
            })
        },
        clickCallback: function (pageNum) {
            this.currentPage = Number(pageNum)
        },
        highLight (text) {
            let searchWord = this.search.trim()
            if (searchWord === '') return text
            if (!text.includes(searchWord)) return text
            const re = new RegExp(searchWord, 'ig')
            return text.replace(re, function (search) {
            return '<span style="background-color:#fbbe4e;font-weight:bold">' + search + '</span>'
            })
        },
        naviOpen: function () {
            this.active = !this.active
            this.navi = !this.navi
        },
        logout() {
            this.$store.commit('reset');
            this.$router.push({name:'sLogin'});
        }
    },
    computed: {
        getItems () {
            let searchWord = this.search.trim()
            if (searchWord === '') return this.tweets
            return this.tweets.filter(e => {
            return e.title.includes(searchWord)
            })
        },
        getLists: function () {
            let current = this.currentPage * this.parPage
            let start = current - this.parPage
            return this.getItems.slice(start, current)
        },
        getPageCount: function () {
            return Math.ceil(this.getItems.length / this.parPage)
        },
        getMaxPage: function () {
            if (this.getLists.length === 50) {
                let max = this.currentPage * 50
                return max
            } else {
                let page = this.currentPage - 1
                let max = 50 * page + this.getLists.length
                return max
            }
        },
        getMinPage: function () {
            if (this.getLists.length === 0) {
                return 0
            } else {
                let min = 50 * this.currentPage - 49
                return min
            }
        }
    },
    watch: {
        search: function () {
        this.currentPage = 1
        }
    }
}
</script>

<style scoped>
.search_register_btn {
    display: flex;
    width: 95vw;
    margin: 20px auto 0;
}

.search_wrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.search_wrap button {
    width: fit-content;
    display: block;
    background-color: #EE9D0B;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 5px 40px;
    margin: 0 3vw 0 auto;
    border: none;
}

.search_wrap input {
    display: block;
    width: 300px;
    height: 30px;
    margin-left: 30px;
    padding: 0 10px;
    border-radius: 10px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

.interval {
    margin-bottom: 0;
}

.staff_top {
    width: 100vw;
    /* height: 105vh; */
    background-size: cover;
}

h1 {
    margin: 15px 40px;
}

.number {
    text-align: right;
    margin-right: 5vw;
    margin-bottom: 10px;
}

.news_list_tables {
    width: 95vw;
    margin: 0 auto;
    padding: 20px 30px;
    border: 1px solid #707070;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.6);
}

.news_list {
    width: 100%;
    height: 55vh;
    overflow: scroll;
}

table {
    width: 100%;
    border-collapse: collapse;
    position: relative;
}

tr.header_tr {
    border-top: 1px solid #707070;
}

tr {
    border-bottom: 1px solid #707070;
    height: 50px;
}

th, td {
    width: 380px;
    text-align: left;
    padding-left: 30px;
    word-break: break-all;
}

th.small_list, td.small_list {
    width: 100px;
    text-align: center;
}

td a {
    text-decoration: underline;
    color: blue;
}

td img {
    width: 2vw;
}

.td img {
    width: 5vw;
}

.false img {
    display: none;
}

.false::after {
    content: 'ー';
}

ul.pagination {
    width: fit-content;
    display: flex;
    margin: 2vw auto;
}

.news_list {
    overflow-y: scroll;
    -ms-overflow-style: none;    /* IE, Edge 対応 */
    scrollbar-width: none;       /* Firefox 対応 */
}
.news_list::-webkit-scrollbar {  /* Chrome, Safari 対応 */
    display:none;
}

.sp_logo {
    display: none;
}

@media screen and (max-width: 767px) {
    header img {
        width: 100%;
    }

    a.header_logo {
        width: 85%;
    }

    header {
        justify-content: normal;
    }

    .burger-btn{
        display: block;
        width: 39px;
        height: 39px;
        position: relative;
        z-index: 3;
    /*   codepenの挙動のため */
        background-color:transparent;
        border:none;
        margin: auto;
    }
    .bar{
        width: 20px;
        height: 1px;
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background-color: #272727;
    }
    .bar_top{
        top: 10px;
    }
    .bar_mid{
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .bar_bottom{
        bottom: 10px;
    }
    .burger-btn.is-active .bar_top{
        transform: translate(-50%,10px) rotate(45deg);
        transition: transform .3s;
    }
    .burger-btn.is-active .bar_mid{
        opacity: 0;
        transition: opacity .3s;
    }
    .burger-btn.is-active .bar_bottom{
        transform: translate(-50%,-8px) rotate(-45deg);
        transition: transform .3s;
    }

    .navi__wrap {
        width: 50vw;
        height: 100vh;
        background-color: #EE9D0B;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        position: fixed;
        top: 0;
        right: 0;
        z-index: 2;
    }

    .navi__wrap li {
        margin-bottom: 2em;
    }

    .navi__wrap li:nth-child(1) {
        margin-top: 2em;
    }

    .navi__wrap a {
        color: #505050;
    }

    button.sp_logout_btn {
        background: none;
        border: none;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: #fff;
        padding: 3vw;
        display: block;
        width: 60%;
        border-radius: 5vw;
        margin: auto;
        color: #505050;
    }

    .header_right {
        display: none;
    }

    table.pc_table {
        display: none;
    }

    h1 {
        margin: 15px 40px;
        font-size: 7vw;
        text-align: center;
    }

    .sp_table {
        display: block;
    }

    .td {
        padding: 1vw 2vw;
    }

    .news_box {
        margin-bottom: 5vw;
        background-color: #ffffffa1;
        padding: 2vw;
        border: 1px solid #707070;
        border-radius: 10px;
    }

    .news_list {
        height: 68.5vh;
    }

    .news_list_tables {
        padding: 0vw 5vw;
        border: none;
        background-color: transparent;
    }

    a.sp_a {
        font-size: 1em;
        word-break: break-all;
    }

    .sp_news_header {
        display: flex;
        margin-bottom: 5vw;
    }

    .sp_date_wrap {
        display: flex;
    }

    .sp_date_txt {
        margin-left: 5vw;
        width: 30%;
        font-size: 3.5vw;
    }

    .sp_date {
        font-size: 3.5vw;
    }

    .sp_logo {
        display: block;
    }
    .pc_logo {
        display: none;
    }

    .header_link2 {
    font-size: 14px;
    }

    .interval2 {
    font-size: 14px;
    }

    .pagenumber {
    font-size: 14px;
    }

    .search_wrap {
        width: 100%;
    }
    
    .search_wrap input {
        width: 50%;
        margin-left: 0;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue